export default class CreateAppDialogController {
    /** @ngInject */
    constructor(DialogService, rules, AlertsActionsApi, ToastService, Loader, ErrorsService, config) {
        this.DialogService = DialogService;
        this.rules = rules;
        this.config = config;
        this.AlertsActionsApi = AlertsActionsApi;
        this.ToastService = ToastService;
        this.Loader = Loader;
        this.ErrorsService = ErrorsService;
        this.onInit();
    }

    onInit() {
        this.genericErrors = this.ErrorsService.getGenericErrors();
        this.rule = {
            title: null,
            type: this.config.type
        };
    }

    create() {
        if (!this.rule.title.length) return;

        this.Loader.show();

        this.AlertsActionsApi.create(this.rule)
            .then((data) => {
                this.rules.push(data);

                this.rule.title = '';
                this.Loader.hide();

                this.ToastService.show(this.ToastService.createSimple({
                    text: 'Rule was created',
                    position: 'bottom right'
                }));

                this.cancel();
            });
    }

    cancel() {
        this.DialogService.cancel();
    }
}



// WEBPACK FOOTER //
// ./app/components/alerts-actions/alerts-actions-nav/dialog/create-alerts-actions/create-alerts-actions.controller.js